import React, { useEffect, useState } from "react";
import {Article} from "../../data/types";
import "../../styles/styles.css"
import axios from "axios";
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File
import parse from 'html-react-parser';


const API_URL = "https://ahuncycle-backend.vercel.app";
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});

const PageArticle = () => {
    const [article, setArticle] = useState<Article>({image:'',date:'',titre: '', description: '',index:0,categorie:'',href:'',html:''})
    useEffect(() => {
      const getArticle = async () => {
        var response:any=[];
        try {
          const config = {mode: 'cors',
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
            }};
          response = await axiosInstance.get("api/articles"+window.location.pathname,config);
          setArticle(response.data);
        } catch (error) {
          console.log("erreur:"+error);
        }
      }
      getArticle(); 
          
    }, []);
   
    return ( 
      <div style={{marginLeft:"50px",marginTop:"50px",marginRight:"50px",textAlign:"justify"}}>
        <div className="article" > {parse(article.html.replaceAll("linkpdf","<img src='https://www.ahuncycle.com/images/pdf.png' //>"))}
        </div>
      </div>
    );
 
};

export default PageArticle;
